import { useTranslation } from "@/i18n/client";
import Select from "@/components/Select";
import { useContext } from "react";
import { EnumerationsContext } from "@/contexts/EnumerationsContext";
import { FormInputProps } from "@/types";
import { InputTooltip } from "@/components/InputTooltip";
import { BRAND, BundleServiceIdFVE } from "@/constants/supplyPoint";

export const FVEBrand = (props: FormInputProps) => {
  const { t } = useTranslation(["supplyPoint", "hints"]);
  const { serviceAttributes } = useContext(EnumerationsContext);

  const brands = serviceAttributes
    .filter(service => service.attribute === BRAND)
    .filter(service => service.bundleServiceId === BundleServiceIdFVE)
    .sort((a, b) => (b.value === "004" ? -1 : a.value === "004" ? 1 : 0))
    .map(service => ({
      value: service.value,
      label: service.name,
    }));

  return (
    <InputTooltip
      tooltipProps={{
        label: t("hints:supplyPoint.bundleServicesFVEBrand"),
      }}>
      <Select label={t("supplyPoint:fveData.fveBrand")} data={brands} {...props} />
    </InputTooltip>
  );
};
